// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { Link } from 'components/Gui';

const Li = styled.li`
  list-style: none;
`;

const MenuItem = ({
  url,
  label,
  children,
  optimizeEvent = false,
  ...rest
}: {
  url: string,
  label: string,
  optimizeEvent?: string | boolean,
  className?: string,
  children: Node,
}) => (
  <Li role="menuitem" {...rest}>
    <Link url={url} optimizeEvent={optimizeEvent} label={label} tabIndex="-1">
      {children}
    </Link>
  </Li>
);

export default MenuItem;
